import React from 'react';
import { Component } from 'react';
import { DownloadButtons } from '../../buttons/download/DownloadButtons';
import './StartScreen.scss';

export default class StartScreen extends Component {
    public render() {
        return (
            <div className="start-container">
                <div className="row">
                    <div className="col">
                        <div className="title">
                            <h1>Aplikacja do medytacji <br/><span className='name'>Mediti:</span></h1>
                        </div>
                        <div className="subtitle">
                            <h2><span className="gold-text">Metoda medytacyjna</span> stanowiąca połączenie różnych form medytacji, technik oddechowych, autohipnozy oraz uważności.</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <DownloadButtons />
                    </div>
                </div>


            </div>
        )
    }
}